import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Immutable from 'immutable';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import {
  getCallCenterReport,
  clearCallCenterReport,
  clearErrorGettingCallCenterReport,
} from '../../../../actions';
import Breadcrumbs from '../../../layout/Breadcrumbs';
import Table from '../../../common/Table';
import ReportToolbar from '../ReportToolbar';
import Loader from '../../../common/Loader';
import Alert from '../../../common/informative/Alert';
import { CALL_CENTER_REPORTS_PATH } from '../../../../config/paths';
import { DEFAULT_PAGE_SIZE } from '../../../../config/constants';
import { CALL_CENTER_REPORT_COLUMNS } from '../../../../../src/config/columns';
import {
  matchPropTypes,
  breadcrumbsPropTypes,
} from '../../../common/resource/proptypes/CommonPropTypes';

class CallCenterReport extends Component {
  static propTypes = {
    getCallCenterReport: PropTypes.func.isRequired,
    clearCallCenterReport: PropTypes.func.isRequired,
    clearErrorGettingCallCenterReport: PropTypes.func.isRequired,
    breadcrumbs: breadcrumbsPropTypes.isRequired,
    report: PropTypes.instanceOf(Immutable.Map),
    loading: PropTypes.bool,
    error: PropTypes.string,
    match: matchPropTypes.isRequired,
  };

  static defaultProps = {
    report: null,
    loading: false,
    error: null,
  };

  constructor(props) {
    super(props);
    this.columns = CALL_CENTER_REPORT_COLUMNS;
    const { id } = this.props.match.params;
    this.props.getCallCenterReport({ id });
  }

  componentWillUnmount() {
    this.props.clearCallCenterReport();
    this.props.clearErrorGettingCallCenterReport();
  }

  handleOnFetchData = (state) => {
    // get id of report
    const { id } = this.props.match.params;
    this.props.getCallCenterReport({ ...state, id });
  };

  download = () => {
    const { report } = this.props;
    const { id } = this.props.match.params;
    if (report) {
      return this.props.getCallCenterReport({
        id,
        reportFormat: 'csv',
        download: true,
      });
    }
    return false;
  };

  renderContent() {
    // check if report is loaded
    const { loading, report, error } = this.props;

    // check if there is an error
    if (error) {
      return <Alert message={error} />;
    }

    // check if report is loading or empty
    if (loading || !report || report.isEmpty()) {
      return <Loader />;
    }

    // check if report is complete
    const reportStatus = report.get('reportStatus');
    if (reportStatus === 'GENERATING') {
      return <Loader />;
    }

    const callCenterReportRows = report.get('callCenterReportRows');
    let data = [];
    let pages = null;
    let defaultPageSize = DEFAULT_PAGE_SIZE;

    if (callCenterReportRows) {
      data = callCenterReportRows.content;
      pages = callCenterReportRows.totalPages;
      defaultPageSize = callCenterReportRows.size;
    }

    const { columns } = this;
    return (
      <div>
        <ReportToolbar download={this.download} disabled={!data.length} />
        <Table
          columns={columns}
          data={data}
          defaultPageSize={defaultPageSize}
          pages={pages}
          loading={loading}
        />
      </div>
    );
  }

  render() {
    return (
      <Container fluid>
        <Breadcrumbs breadcrumbs={this.props.breadcrumbs} />
        <h1>Reporte Call Center</h1>
        <p>
          Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
          eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad
          minim veniam, quis nostrud exercitation ullamco laboris nisi ut
          aliquip ex ea commodo consequat.
        </p>
        {this.renderContent()}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  breadcrumbs: [
    ...state.ReportUnit.UnitHome.get('breadcrumbs'),
    {
      text: 'Call Center',
      href: CALL_CENTER_REPORTS_PATH,
    },
    {
      text: 'Ver',
      href: state.routing.location.pathname,
    },
  ],
  error: state.ReportUnit.CallCenterReport.get('current').get('error'),
  report: state.ReportUnit.CallCenterReport.get('current').get('content'),
  loading: state.ReportUnit.CallCenterReport.get('current').get('loading'),
});

const mapDispatchToProps = {
  getCallCenterReport,
  clearCallCenterReport,
  clearErrorGettingCallCenterReport,
};

export default connect(mapStateToProps, mapDispatchToProps)(CallCenterReport);
